import { Injectable, inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";
import { FrontendApi } from "app/shared/frontend.api";
import { Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
export class AuthService {
    private _httpClient = inject(HttpClient);
    private _router = inject(Router);

    private _authenticated: boolean = false;
    private clientId = '580320127188-vdpe8rspbcpkjnr6lse4ulusop4gpo66.apps.googleusercontent.com';
    private scopes = 'openid email profile https://www.googleapis.com/auth/adwords';

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for access token
     */
    set accessToken(token: string) {
        localStorage.setItem('token', token);
    }

    get accessToken(): string {
        return localStorage.getItem('token') ?? '';
    }

    signIn(): void {
        const params = new URLSearchParams({
            client_id: this.clientId,
            redirect_uri: FrontendApi.oauth + '/google/callback',
            response_type: "code",
            include_granted_scopes: "true",
            scope: this.scopes,
            access_type: "offline",          
            prompt: "consent"
        });

        window.location.href = "https://accounts.google.com/o/oauth2/v2/auth?" + params.toString();
    }

    signOut(): Observable<void> {
        return this._httpClient.post<void>(`${FrontendApi.oauth}/sign-out`, null);
    }

    exchangeCode(code: string): Observable<any> {
        const requestDto = {
            code
        }
        return this._httpClient.post<any>(`${FrontendApi.oauth}/exchange`, requestDto);
    }
    
}